import { ConditionLibraryModuleType, PermissionAction } from '@coin/shared/core/util-enums';
import { EmploymentConditionLibraryModuleSettings } from '@coin/shared/ecl/util';
import { Store } from '@ngxs/store';
import { PermissionsService } from './permissions.service';

type Settings<K extends ConditionLibraryModuleType> = EmploymentConditionLibraryModuleSettings[K];

export class EclViewAccessHelper {
  public static hasOnlyViewAccess(
    store: Store,
    settings: Settings<ConditionLibraryModuleType>,
    permissionsService: PermissionsService
  ): boolean {
    if (this.isAdmin(settings, permissionsService)) return false;

    const isEclUser = permissionsService.hasPermissions(...settings.readOnlyAccess);
    const allowedActions = [
      PermissionAction.All,
      PermissionAction.Create,
      PermissionAction.Update,
      PermissionAction.Delete
    ];
    const hasOnlyReadAccess =
      permissionsService.hasPermissionsAndActions({
        resources: settings.readOnlyAccess,
        actions: [PermissionAction.Read]
      }) &&
      !permissionsService.hasPermissionsAndActions({ resources: settings.readOnlyAccess, actions: allowedActions });

    return isEclUser && hasOnlyReadAccess;
  }

  public static hasDocGenPermissions(
    store: Store,
    settings: Settings<ConditionLibraryModuleType>,
    permissionsService: PermissionsService
  ): boolean {
    if (this.isAdmin(settings, permissionsService)) return true;

    const hasDocGenPermissions = permissionsService.hasPermissions(...settings.docGenResources);

    if (hasDocGenPermissions) return true;

    return !this.hasOnlyViewAccess(store, settings, permissionsService);
  }

  private static isAdmin(
    settings: Settings<ConditionLibraryModuleType>,
    permissionsService: PermissionsService
  ): boolean {
    const isAdmin = permissionsService.hasPermissions(...settings.adminResources);
    return isAdmin || permissionsService.isSuperAdmin();
  }
}
